var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4v16h16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.514 16.591c-.19 0-.326-.039-.407-.117-.08-.078-.12-.213-.12-.404V7.854c0-.186.04-.32.12-.4.08-.08.216-.12.407-.12h1.27c.186 0 .32.04.4.12.08.08.12.214.12.4l.001 3.913.011-.03c.01-.02.021-.04.034-.058a.695.695 0 0 1 .209-.186l6.412-3.769c.065-.035.14-.07.222-.104a.619.619 0 0 1 .24-.052c.14 0 .269.054.388.162.12.109.179.285.179.528v7.409c0 .243-.06.419-.179.527a.566.566 0 0 1-.387.163.642.642 0 0 1-.245-.052 1.357 1.357 0 0 1-.218-.111l-6.412-3.77a.647.647 0 0 1-.205-.185l-.036-.06-.013-.035v3.926c0 .191-.04.326-.12.404-.081.078-.215.117-.401.117h-1.27z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0v24h24z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.ac0206c2.svg";
export { ForwardRef as ReactComponent };